<template>
  <v-hover v-slot:default="{ hover }">
    <div class="section-nav" v-bind:class="{ active: hover }">
      <v-icon color="white" large>mdi-chevron-left</v-icon>
      <div
        class="nav-content"
        v-bind:class="{ invisible: !hover, expand: hover, visible: hover }"
      >
        <a class="nav-cell text-1 color-white" href="#welcome">Home</a>
        <a class="nav-cell text-1 color-white" href="#wms"
          >What Makes Us Special</a
        >
        <a class="nav-cell text-1 color-white" href="#industries">Industries</a>
        <a class="nav-cell text-1 color-white" href="#processMap"
          >Process Map</a
        >
        <a class="nav-cell text-1 color-white" href="#partners">Partners</a>
      </div>
    </div>
  </v-hover>
</template>

<script>
export default {};
</script>

<style>
.section-nav {
  width: 50px;
  height: 100px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  top: calc(50% - 50px);
  background: rgba(1, 1, 1, 0.5);
  z-index: 1030;
  transition: 0.3s ease-in-out;
}

.nav-content {
  width: 0;
  opacity: 0;
  height: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.nav-cell {
  width: 100%;
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-items: center;
  align-items: center;
  color: white;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}

.nav-cell:hover {
  font-weight: bold;
  transition: 0.3s ease-in-out;
}

.expand {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  transition: 0.3s ease-in-out;
}

.active {
  width: 230px;
  height: 400px;
  top: calc(50% - 200px);
  transition: 0.3s ease-in-out;
}

.invisible {
  visibility: hidden;
  transition: 0.3s ease-in-out;
}

.visible {
  visibility: visible;
  opacity: 1;
  transition: 0.3s ease-in-out;
}
</style>
